<template>
  <div>
    <template v-if="firstStep">
      <template v-if="loading>0">
        <Loader :delay="0"></Loader>
      </template>
      <template v-else>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Código visitador">
                <!-- <b-form-input value="" disabled></b-form-input> -->
                <b-form-select @input="updateUser" v-model="user.username" :options="users_options" class="mb-3" text-field="username" value-field="username"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Nombre visitador">
                <input class="form-control" :value="user.first_name + ' ' + user.last_name" disabled>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Visitado por gestor">
                <!-- <b-form-input v-model="visit.visitado_gestor"></b-form-input> -->
                <div class="form-control" >
                  <switches
                  v-model="visit.visitado_gestor"
                  style="margin-top: .5rem;"
                  color="blue">
                  </switches>
                  &nbsp;
                  <span v-if="visit.visitado_gestor">
                    Sí
                  </span>
                  <span v-else>
                    No
                  </span>
                </div>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Status">
                <!-- <b-form-input v-model="visit.status_visita"></b-form-input> -->
                <b-form-select v-validate="'required'" name="Status" v-model="visit.status_visita" :options="status_options" class="mb-3" text-field="visita_status" value-field="visita_status"/>
                <span class="error">{{ errors.first('Status') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Fecha y hora planificada">
                <!-- <b-form-input v-model="visit.fecha_hora_visita" :disabled="!visit.status_visita"></b-form-input> -->
                <b-input-group>
                  <datetime
                  v-validate="(visit.status_visita === 'PLANIFICADA' || visit.status_visita === 'CANCELADA') ? 'required':''"
                  name="Fecha y hora planificada"
                  v-model="visit.fecha_hora_proxima_visita"
                  input-class="form-control"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  type="datetime"
                  :auto="true"
                  :minute-step="15"
                  value-zone="local"
                  zone="local">
                  </datetime>
                  <b-input-group-text slot="append" @click="visit.fecha_hora_proxima_visita = ''">
                    <strong class="text-danger"><i class="fa fa-times"></i></strong>
                  </b-input-group-text>
                </b-input-group>
                <span class="error">{{ errors.first('Fecha y hora planificada') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Fecha y hora finalizada">
                <!-- <b-form-input v-model="visit.fecha_hora_visita" :disabled="!visit.status_visita"></b-form-input> -->
                <b-input-group>
                  <datetime
                  v-validate="(visit.status_visita === 'FINALIZADA') ? 'required':''"
                  name="Fecha y hora finalizada"
                  v-model="visit.fecha_hora_visita"
                  input-class="form-control"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  type="datetime"
                  :auto="true"
                  :minute-step="15"
                  value-zone="local"
                  :max-datetime="currentDate"
                  zone="local">
                  </datetime>
                  <b-input-group-text slot="append" @click="visit.fecha_hora_visita = ''">
                    <strong class="text-danger"><i class="fa fa-times"></i></strong>
                  </b-input-group-text>
                </b-input-group>
                <span class="error">{{ errors.first('Fecha y hora finalizada') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Tipo actividad">
                <!-- <b-form-input v-model="visit.tipo_actividades"></b-form-input> -->
                <b-form-select v-validate="'required'" name="Tipo actividad" v-model="visit.tipo_actividad" :options="tipo_actividad_options" class="mb-3" text-field="descripcion" value-field="descripcion"/>
                <span class="error">{{ errors.first('Tipo actividad') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Resultado">
                <!-- <b-form-input v-model="visit.id_resultado_visita"></b-form-input> -->
                <b-form-select v-validate="(visit.status_visita === 'FINALIZADA') ? 'required':''" name="Resultado" v-model="visit.id_resultado_visita" :options="resultados_options" class="mb-3" text-field="resultado" value-field="id"/>
                <span class="error">{{ errors.first('Resultado') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Observaciones">
                <b-form-input v-validate="ObsValidate" name="Observaciones" v-model="visit.observaciones"></b-form-input>
                <span class="error">{{ errors.first('Observaciones') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
          </b-row>
          <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Invitados">
                <b-form-input v-model="visit.invitados"></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Enviar email a invitados">
                <a class="btn btn-secondary" target="_top" :href="mailText">Enviar</a>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: right;">
            <b-button @click="goBackDetails">Cancelar</b-button>
            <b-button @click="saveStep">Guardar</b-button>
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-else>
      <template v-if="loading>0">
        <Loader :delay="0"></Loader>
      </template>
      <template v-else>
        <h2>
          Actualización datos gestión
        </h2>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Clase establecimiento GN">
                <b-form-select v-validate="'required'" name="Clase establecimiento GN" v-model="feature['id_clase_establecimiento_gn_'+group].id" :options="clase_establecimiento_comercial_options" class="mb-3" text-field="tipo" value-field="id"/>
                <span class="error">{{ errors.first('Clase establecimiento GN') }}</span>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col v-if="group==='comercial'">
            <b-form>
                <b-form-group v-if="group==='comercial'" style="font-size: 1rem;" label="Gas en finca">
                  <b-form-select v-validate="'required'" name="Gas en finca" v-model="feature.id_gas_finca.id" :options="gas_options" class="mb-3" text-field="gas" value-field="id"/>
                  <span class="error">{{ errors.first('Gas en finca') }}</span>
                </b-form-group>
                <b-form-group v-if="group==='caldera'" style="font-size: 1rem;" label="Gas en finca">
                  <b-form-select v-validate="'required'" name="Gas en finca" v-model="feature.id_gas_en_finca.id" :options="gas_options" class="mb-3" text-field="gas" value-field="id"/>
                  <span class="error">{{ errors.first('Gas en finca') }}</span>
                </b-form-group>
              </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Status gestión">
                  <b-form-select v-validate="'required'" name="Status gestión" v-model="feature['id_status_gestion_'+group].id" :options="status_gestion_options" class="mb-3" text-field="status" value-field="id"/>
                  <span class="error">{{ errors.first('Status gestión') }}</span>
                </b-form-group>
              </b-form>
          </b-col>
          <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Motivo no potencial">
                <b-form-select v-validate="noPotencialValidate" name="Motivo no potencial" v-model="feature.motivo_no_potencial" :options="motivo_no_potencial_options" class="mb-3" text-field="motivo" value-field="motivo"/>
                  <span class="error">{{ errors.first('Motivo no potencial') }}</span>
                </b-form-group>
              </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: right;">
            <b-button @click="firstStep = true">Cancelar</b-button>
            <b-button @click="saveVisit">Guardar</b-button>
          </b-col>
        </b-row>
      </template>
    </template>
  </div>
</template>

<style>

</style>

<script>
/* eslint-disable */
import Datepicker from 'vuejs-datepicker'
import Switches from 'vue-switches'
import Vue from 'vue'
import Loader from '@/components/Layout/Loader.vue'
import moment from 'moment'

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'ManageVisitsResultsDetailEdit',
  props: ['id-visita', 'group'],
  components: { Loader, Datepicker, Switches },
  data () {
    return {
      firstStep:true,
      endpoint:'',
      loading:0,
      feature:{direccion_no_estructurada:''},
      visit: {
        id: null,
        id_comercial: null,
        id_caldera: null,
        status_visita: null,
        fecha_hora_visita: null,
        tipo_actividades: null,
        id_resultado_visita: null,
        observaciones: null,
        visitado_gestor: false,
        codigo_visitador: null,
        fecha_hora_proxima_visita: null,
        motivo_no_potencial:null
      },
      status_options: [],
      status_gestion_options: [],
      tipo_actividad_options: [],
      resultados_options: [],
      user: {username:''},
      users_options: [],
      gas_options: [],
    }
  },
  computed: {
    currentDate: function () {
      return moment().format()
    },
    ObsValidate: function () {
      if (this.visit.status_visita === 'FINALIZADA') {
        return 'required|max:1000'
      } else {
        return 'max:1000'
      }
    },
    mailText: function () {
      var subject = '[Cita Geovisor] '
      if (this.group === 'comercial') {
        subject = subject + 'CRM COMERCIAL: '
      } else {
        subject = subject + 'CRM CALDERA CENTRALIZADA: '
      }
      subject = subject + '[' + encodeURIComponent(this.visit.status_visita) + '] – '
      subject = subject + '[' + encodeURIComponent(this.feature.direccion_no_estructurada) + ']'

      return 'mailto:' + this.mail + '?subject=' + subject
    },
    noPotencialValidate: function () {
      if (this.feature['id_status_gestion_' + this.group].id === 8) {
        return {required: true}
      } else {
        return {is: null}
      }
    }
  },
  mounted: function () {
    this.loading = 1
    if (this.group === 'comercial') {
      this.endpoint = 'comercial_visitas/'
    } else if (this.group === 'caldera') {
      this.endpoint = 'caldera_visitas/'
    } else {
      this.endpoint = 'entidad_visitas/'
    }

    this.$http.get(this.endpoint + this.idVisita + '/').then(result => {
      this.visit = result.data
      this.loadFeature()
      this.initLists()
      this.loading = this.loading - 1
    })
  },
  methods: {
    saveStep: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario')
        } else {
          this.firstStep = false
        }
      })
    },
    saveVisit: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario')
        } else {
          this.visit.codigo_visitador = this.user.username

          if (this.visit.id_comercial_id) {
            this.visit.id_comercial = this.visit.id_comercial_id
          }
          if (this.visit.id_caldera_id) {
            this.visit.id_caldera = this.visit.id_caldera_id
          }

          if (this.visit.fecha_hora_proxima_visita) {
            this.visit.fecha_hora_proxima_visita = this.visit.fecha_hora_proxima_visita.split('+')[0] + '+00:00'
          } else if (this.visit.fecha_hora_proxima_visita === '') {
            this.visit.fecha_hora_proxima_visita = null
          }
          if (this.visit.fecha_hora_visita) {
            this.visit.fecha_hora_visita = this.visit.fecha_hora_visita.split('+')[0] + '+00:00'
          } else if (this.visit.fecha_hora_visita === '') {
            this.visit.fecha_hora_visita = null
          }

          var th = this
          this.loading = this.loading + 1
          this.$http.put(this.group + '2/' + this.feature.id + '/', this.feature).then(result => {
            if (th.visit.id) {
              th.$http.put(th.endpoint + th.visit.id + '/', th.visit).then(result => {
                th.goBackDetails()
                th.loading = th.loading - 1
              })
            } else {
              th.$http.post(th.endpoint, th.visit).then(result => {
                th.goBackDetails()
                th.loading = th.loading - 1
              })
            }
          })
        }
      })
    },
    loadFeature:function(){
      this.loading = this.loading + 1
      this.$http.get(this.group + '/' + this.visit['id_'+this.group] + '/').then(result => {
        this.feature = result.data
        this.loading = this.loading - 1
      })
    },
    updateUser: function () {
      this.user = this.users_options.filter(e => e.username === this.user.username)[0]
    },
    initLists: function () {
      this.loading = this.loading + 1
      Promise.all([
        this.$http.get('status_visitas/', {params: {not_paginated: true}}),
        this.$http.get('tipo_actividad_visitas_' + this.group + '/', {params: {not_paginated: true}}),
        this.$http.get('resultados_visitas/', {params: {not_paginated: true}}),
        this.$http.get('users2/', {params: {not_paginated: true}}),
        this.$http.get('clase_establecimiento_comercial/', {params: {not_paginated: true}}),
        this.$http.get('gas_finca/', {params: {not_paginated: true}}),
        this.$http.get('status_gestion_' + this.group + '/', {params: {not_paginated: true}}),
        this.$http.get('motivo_no_potencial_comercial/', {params: {not_paginated: true}})
      ]).then(results => {
        this.status_options = [{id: null, visita_status: ''}].concat(results[0].data)
        this.tipo_actividad_options = [{id: null, descripcion: ''}].concat(results[1].data)
        this.resultados_options = [{id: null, resultado: ''}].concat(results[2].data)
        this.users_options = results[3].data
        this.clase_establecimiento_comercial_options = [{id: null, tipo: ''}].concat(results[4].data)
        this.gas_options = [{id: null, gas: ''}].concat(results[5].data)
        this.status_gestion_options = [{id: null, status: ''}].concat(results[6].data)
        this.motivo_no_potencial_options = [{id: null, motivo: ''}].concat(results[7].data)

        if (this.visit.motivo_no_potencial && this.motivo_no_potencial_options.findIndex(e => e.motivo === this.visit.motivo_no_potencial) < 0) {
          this.motivo_no_potencial_options = this.motivo_no_potencial_options.concat([{id: 999, motivo: this.visit.motivo_no_potencial}])
        }

        this.user = this.users_options.filter(e => e.username === this.visit.codigo_visitador)[0]
        this.loading = this.loading - 1
      })
    },
    goBackDetails () {
      this.$parent.processData()
      this.$parent.editingVisit = 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisitsResultsDetailEdit.vue